export default {
  margin10px: "10px",
  margin20px: "20px",
  margin140px: "140px",
}
